// eslint-disable-next-line import/no-anonymous-default-export
export default {
    // domain: "http://localhost:4001"
    // domain: "https://admon.finanservs.com:4001"
    domain: "" 
}